import { HierarchyNodeActionCreator, HierarchySearchActionCreator } from '@aon/tws-common-ui-hierarchy';
import * as React from 'react';
import { connect } from 'react-redux';
import { DistributionOptionWrapper } from '../../components/audience/DistributionOptionWrapper';
import { AudienceMode } from '../../components/audiences/AudienceMode';
import Constants from '../../constants';
import { ActionCreators } from '../../store/AudienceDetailsStore';
import { ActionCreators as CommonHierarchyActionCreators } from '../../store/CommonHierarchyStore';
import { ActionCreators as DistributionContactActionCreators } from '../../store/DistributionContactStore';
import { ActionCreators as DistributionFileActionCreators } from '../../store/DistributionFileStore';
import { ActionCreators as DistributionHierarchyActionCreators } from '../../store/DistributionHierarchyStore';
import { ActionCreators as EmailActionCreators } from '../../store/EmailStore';
import * as EmailTemplateActionCreators from '../../store/EmailTemplateSlice';
import { ActionCreators as ExternalHierarchyActionCreators } from '../../store/ExternalHierarchyStore';
import { NavigationActions } from '../../store/NavigationActions';
import { ActionCreators as SurveyParticipantActionCreators } from '../../store/SurveyParticipantStore';
import { IApplicationState } from '../../store/index';
import { AudiencePageStateSetterRouteProps } from '../state-setter/AudiencePageStateSetterBase';
import { DistributionOptionsPageStateSetter } from '../state-setter/DistributionOptionsPageStateSetter';

const hierarchyNodeActionCreator = new HierarchyNodeActionCreator(Constants.ORGMANAGER_HIERARCHIES_URL, false);
const hierarchySearchActionCreator = new HierarchySearchActionCreator(hierarchyNodeActionCreator, Constants.ORGMANAGER_HIERARCHIES_URL);

export const DistributionOptionsContainer = connect(
	(state: IApplicationState) => ({
		...state.audienceDetails,
		...state.emailTemplates,
		...state.distributionList,
		...state.distributionContacts,
		...state.surveyBuilder,
		...state.email,
		...state.externalHierarchy,
		hierarchy: state.Hierarchy,
		...state.distributionHierarchy,
		audienceSource: state.survey.surveyEditModel.audienceSource,
		loadingAudienceSource: state.survey.isLoading,
		surveySupportedCultures: state.survey.surveyEditModel.supportedCultures,
		...state.survey.surveyEditModel.survey,
	}),
	{
		...ActionCreators,
		...NavigationActions,
		...EmailActionCreators,
		...EmailTemplateActionCreators,
		...DistributionFileActionCreators,
		...DistributionContactActionCreators,
		...SurveyParticipantActionCreators,
		...DistributionHierarchyActionCreators,
		...ExternalHierarchyActionCreators,
		...SurveyParticipantActionCreators,
		...CommonHierarchyActionCreators,
		...hierarchyNodeActionCreator,
		...hierarchySearchActionCreator,
	},
)(DistributionOptionWrapper as any) as any;

export class DistributionOptionsPage extends React.PureComponent<AudiencePageStateSetterRouteProps> {
	public render() {
		return (
			<>
				<DistributionOptionsContainer {...this.props} mode={AudienceMode.Edit} />
				<DistributionOptionsPageStateSetter {...this.props} />
			</>
		);
	}
}
